import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  exportHistoryExcel({ commit }, params) {
    commit('setToggleLoading', true);

    const {
      sendMethods,
      rangeDate,
      orderByList,
    } = params;

    const {
      end,
      start,
    } = rangeDate;

    const config = {
      date_start: start,
      date_end: end,
      logistic_provider_ids: [],
      performance_lp_type: null,
      requested_page: 1,
      rows_per_page: 25,
      sort_direction: orderByList,
      sort_field: sendMethods,
      table_status: null,
    };

    return GraphQlClient.mutation(
      `mutation(
        $dateStart: String
        $dateEnd: String
        $logisticProviderIds: [Int]
        $performanceLpType: [String]
        $requestedPage: Int
        $rowsPerPage: Int
        $sortDirection: String
        $sortField: String
        $tableStatus: String) {
        transactionsExportExcel(
          dateStart: $dateStart
          dateEnd: $dateEnd
          logisticProviderIds: $logisticProviderIds
          performanceLpType: $performanceLpType
          requestedPage: $requestedPage
          rowsPerPage: $rowsPerPage
          sortDirection: $sortDirection
          sortField: $sortField
          tableStatus: $tableStatus
        ) {
          status
        }
      }`, config)
    .then(({ data }) => {
      const { transactionsExportExcel } = data || {};
      const { status } = transactionsExportExcel || {};
      commit('setToggleLoading', false);
      ScToast.open({ message: status, duration: 5000, type: 'is-success' });
      Promise.resolve(data);
    })
    .catch((err) => {
      commit('setToggleLoading', false);
      return Promise.resolve(err);
    });
  },
  exportHistoryExcelStatus({ commit }, params) {
    commit('setToggleLoading', true);

    const {
      providers,
      rangeDateStatus,
      statusList,
    } = params;

    const {
      end,
      start,
    } = rangeDateStatus;

    const config = {
      date_start: start,
      date_end: end,
      logistic_provider_ids: providers.id === 0 ? [] : [providers.id],
      performance_lp_type: statusList.label === 'Status' ? null : [statusList.value],
      requested_page: 1,
      rows_per_page: 25,
      sort_direction: 'ascending',
      sort_field: 'order_number',
      table_status: statusList.value === '' ? null : statusList.value,
      shipment_table_state: statusList.code,
      status: statusList.label === 'Status' ? null : statusList.code.toString(),
    };

    return GraphQlClient.mutation(
      `mutation(
        $dateStart: String
        $dateEnd: String
        $logisticProviderIds: [Int]
        $performanceLpType: [String]
        $requestedPage: Int
        $rowsPerPage: Int
        $sortDirection: String
        $sortField: String
        $tableStatus: String
        $provider: String
        $shipment_table_state: Int
        $status: String
        ) {
        transactionsExportExcel(
          dateStart: $dateStart
          dateEnd: $dateEnd
          logisticProviderIds: $logisticProviderIds
          performanceLpType: $performanceLpType
          requestedPage: $requestedPage
          rowsPerPage: $rowsPerPage
          sortDirection: $sortDirection
          sortField: $sortField
          tableStatus: $tableStatus
          provider: $provider
          shipment_table_state: $shipment_table_state
          status: $status
        ) {
          status
        }
      }`, config)
    .then(({ data }) => {
      const { transactionsExportExcel } = data || {};
      const { status } = transactionsExportExcel || {};
      commit('setToggleLoading', false);
      ScToast.open({ message: status, duration: 5000, type: 'is-success' });
      Promise.resolve(data);
    })
    .catch((err) => {
      commit('setToggleLoading', false);
      return Promise.resolve(err);
    });
  },
  getLogisticProviders({ commit }, active = false) {
    commit('setToggleLoading', true);

    return GraphQlClient.query(`
    query($active: Boolean) {
      logisticProviders(active: $active) {
        id
        name
        delivery_methods {
          id
          name
          logo_url
          enabled
          pending_contracts
          type
        }
      }
    }`, { active })
      .then(({ data = {} }) => {
        commit('setToggleLoading', false);
        const { logisticProviders = [] } = data;

        commit('setLogisticProviders', logisticProviders);
        return Promise.resolve(logisticProviders);
      })
      .catch((err) => {
        commit('setToggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/transation-filter/store/actions.js